
import classnames from 'classnames';
import * as moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';

// utils
import { Translations } from '../../../../utils';
// constant
import { FORM_REFS } from '../../../../constants';
// restClient
import { aemHostClient, eapiClient } from '../../../../restClient';
// children
import Dynamicform from '../../../common/Dynamicform/dynamicForm';

import { deleteRafPackDetails, rafPackDetails, rafPackNotFound } from '../../actions/actionCreator';
//style
import './Documentation.css';

class Documentation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      documentationDetails: undefined,
      formData: {},
      options: [],
      csCancelStatus: {},
      csCancelReason: {},
      caseOwnerPrimaryUpdate: false,
      caseOwnerSecondaryUpdate: false,
      caseRequestorUpdate: false
    };
  }

  getFormData = (formData) => {
    this.setState({ formData });
  }


  resetValues = () => {
    this.props.deleteRafPackDetails();
    this.setState({
      documentationDetails: {
        ...this.state.documentationDetails,
        RAF: ""
      }
    })
  }

  resetEntity = () => {
    this.props.deleteRafPackDetails();
  }

  componentDidMount() {
    aemHostClient("/aemData/formData/json_manual-case-scanned-uploads-form")
      .then(({ data, status }) => {
        this.setState({ scannedUploadsJson: data.par })
      });

    eapiClient(`/cases/${this.props.caseNum}/clientsphere-cases`)
      .then(({ data: { responseData } }) => {
        var caseDetails = responseData.caseDetails;
        caseDetails.outputDocumentType = responseData.caseDetails.outputDocumentType !== undefined ? responseData.caseDetails.outputDocumentType === "RAF" ? 1 : 2 : '';
        caseDetails.createdBy = responseData.caseDetails.createdBy ? responseData.caseDetails.createdBy.name : undefined;
        caseDetails.caseRequestorSearch = responseData.caseDetails.caseRequestor ? responseData.caseDetails.caseRequestor.value : undefined;
        caseDetails.primaryCaseOwnerSearch = responseData.caseDetails.primaryCaseOwner ? responseData.caseDetails.primaryCaseOwner.value : undefined;
        caseDetails.secondaryCaseOwnerSearch = responseData.caseDetails.secondaryCaseOwner ? responseData.caseDetails.secondaryCaseOwner.value : undefined;
        caseDetails.RAF = responseData.caseDetails.oldPackNumber ? responseData.caseDetails.oldPackNumber : '';
        caseDetails.status = {
          name: responseData.caseDetails.statusValue,
          value: responseData.caseDetails.status
        }
        if (responseData.caseDetails.cancelledDate) {
          caseDetails.cancelledDate = moment(responseData.caseDetails.cancelledDate).format("DD MMM YYYY")
        }
        if (responseData.caseDetails.finalizeDate) {
          caseDetails.finalizeDate = moment(responseData.caseDetails.finalizeDate).format("DD MMM YYYY")
        }
        if (responseData.caseDetails.glsCustomerAckComplete) {
          caseDetails.glsCustomerAckComplete = moment(responseData.caseDetails.glsCustomerAckComplete).format("DD MMM YYYY")
        }
        if (responseData.caseDetails.scannedDocUploadDate) {
          caseDetails.scannedDocUploadDate = moment(responseData.caseDetails.scannedDocUploadDate).format("DD MMM YYYY")
        }
        let mode = "create"
        if (caseDetails.status !== undefined && (caseDetails.status.name !== "" && caseDetails.status.value !== "")) {
          mode = "edit"
        }
        this.setState({
          documentationDetails: caseDetails,
          mode: mode,
          scannedUploads: responseData.caseDetails.signedDocuments
        })
        if (responseData.caseDetails.oldPackNumber !== "" && responseData.caseDetails.outputDocumentType === 2) {
          eapiClient(`/cases/${responseData.caseDetails.oldPackNumber}/pack-details`)
            .then(({ data: { responseData } }) => {
              this.props.rafPackDetails(responseData = { ...responseData, isRafPack: true });
            })
        }
      })
    aemHostClient("/aemData/formData/json_manual-case-documentation-raf-model-popup")
      .then(({ data, status }) => {
        this.setState({ rafValidationPopup: data.par })
      });

  }

  getPayload = (requestPayload) => {
    if (this.state.caseOwnerPrimaryUpdate === true || this.state.formData.primaryCaseOwnerOther !== undefined) {
      requestPayload = {
        ...requestPayload,
        primaryCaseOwner: this.state.primaryCaseOwnerSearch || { name: this.state.formData.primaryCaseOwnerOther, value: this.state.formData.primaryCaseOwnerOther }
      }
    }
    if (this.state.caseOwnerSecondaryUpdate === true | this.state.formData.secondaryCaseOwnerOther !== undefined) {
      requestPayload = {
        ...requestPayload,
        secondaryCaseOwner: this.state.secondaryCaseOwnerSearch || { name: this.state.formData.secondaryCaseOwnerOther, value: this.state.formData.secondaryCaseOwnerOther }
      }
    }
    if (this.state.caseRequestorUpdate === true || this.state.formData.caseRequestorOther !== undefined) {
      requestPayload = {
        ...requestPayload,
        caseRequestor: this.state.caseRequestorSearch || { name: this.state.formData.caseRequestorOther, value: this.state.formData.caseRequestorOther }
      }
    }
    if (this.state.formData.cancelationReason !== undefined) {
      requestPayload = {
        ...requestPayload,
        cancelationReason: this.state.formData.cancelationReason.value
      }
    }

    if (requestPayload.outputDocumentType === "SAF") {
      requestPayload = {
        ...requestPayload,
        oldPackNumber: this.state.formData.RAF
      }
    } else if (requestPayload.outputDocumentType === "RAF") {
      requestPayload = {
        ...requestPayload,
        oldPackNumber: ""
      }
    }

    let date = this.state.formData["cancelledDate"];
    let caseHistoryEventTriggerCheck = this.state.documentationDetails.cancelledDate !== date;
    if (date !== undefined && caseHistoryEventTriggerCheck) {
      requestPayload = {
        ...requestPayload,
        cancelledDate: new Date(this.state.formData["cancelledDate"]).getTime()
      }
    }

    date = this.state.formData["finalizeDate"];
    caseHistoryEventTriggerCheck = this.state.documentationDetails.finalizeDate !== date;
    if (date !== undefined && caseHistoryEventTriggerCheck) {
      requestPayload = {
        ...requestPayload,
        finalizeDate: new Date(this.state.formData["finalizeDate"]).getTime()
      }
    }

    date = this.state.formData["scannedDocUploadDate"];
    caseHistoryEventTriggerCheck = this.state.documentationDetails.scannedDocUploadDate !== date;
    if (date !== undefined && caseHistoryEventTriggerCheck) {
      requestPayload = {
        ...requestPayload,
        scannedDocUploadDate: new Date(this.state.formData["scannedDocUploadDate"]).getTime()
      }
    }

    date = this.state.formData["glsCustomerAckComplete"];
    if (date !== undefined) {
      requestPayload = {
        ...requestPayload,
        glsCustomerAckComplete: new Date(this.state.formData["glsCustomerAckComplete"]).getTime()
      }
    }

    return requestPayload;
  }

  onFormSubmit = (event, apiUrl) => {
    let caseStatus = this.state.formData.status;
    var requestPayload = {
      negotiated: this.state.formData.negotiated,
      migrationCustomer: this.state.formData.migrationCustomer,
      outputDocumentType: this.state.formData.outputDocumentType !== undefined ? this.state.formData.outputDocumentType === "1" ? "RAF" : "SAF" : '',
      clientSphereCase: true,
      status: caseStatus.value,
      statusValue: caseStatus.name,
      countryOfCaseOwner: this.state.formData.countryOfCaseOwner,
    };

    requestPayload = this.getPayload(requestPayload);

    eapiClient(`/cases/${this.props.caseId}/clientsphere-cases`, {
      method: "PUT",
      data: JSON.stringify(requestPayload)
    })
      .then(({ data }) => {
        this.props.msaCases ? '' : this.props.setTabActive(3)
      })
  }

  onFileUpload = (event) => {
    const formData = new FormData();
    formData.append('files', event.target.files[0]);

    eapiClient(`/cases/${this.props.caseId}/uploadDocument`, {
      method: 'POST',
      headers: {
        'content-type': 'multipart/form-data'
      },
      timeout: 100000,
      data: formData
    })
      .then(({ data }) => {
        this.setState({ scannedUploads: data.responseData });
      });
  }

  onFileDelete = (file) => {
    eapiClient(`/cases/${this.props.caseId}/document/${file.id}`, { method: 'DELETE' })
      .then(({ data }) => {
        this.setState({ scannedUploads: data.responseData });
      });
  }

  setSelectedOptions = (value, name) => {
    if (value === "Other") {
      if (name === "caseRequestorSearch") {
        this.setState({
          documentationDetails: {
            ...this.state.documentationDetails,
            caseRequestorOther: ""
          }
        });
        document.getElementById('caseRequestorOtherField').classList.remove('noDisplay');
      } else if (name === "primaryCaseOwnerSearch") {
        this.setState({
          documentationDetails: {
            ...this.state.documentationDetails,
            primaryCaseOwnerOther: ""
          }
        });
        document.getElementById('primaryCaseOwnerOtherField').classList.remove('noDisplay');
      } else if (name === "secondaryCaseOwnerSearch") {
        this.setState({
          documentationDetails: {
            ...this.state.documentationDetails,
            secondaryCaseOwnerOther: ""
          }
        });
        document.getElementById('secondaryCaseOwnerOtherField').classList.remove('noDisplay');
      }
    } else {
      if (name === "caseRequestorSearch") {
        document.getElementById('caseRequestorOtherField').classList.add('noDisplay');
        this.setState({
          caseRequestorUpdate: true,
          caseRequestorSearch: {
            name: value.email,
            value: value.email
          }
        });
      } else if (name === "primaryCaseOwnerSearch") {
        document.getElementById('primaryCaseOwnerOtherField').classList.add('noDisplay');
        this.setState({
          caseOwnerPrimaryUpdate: true,
          primaryCaseOwnerSearch: {
            name: value.email,
            value: value.email
          }
        });
      } else if (name === "secondaryCaseOwnerSearch") {
        document.getElementById('secondaryCaseOwnerOtherField').classList.add('noDisplay');
        this.setState({
          caseOwnerSecondaryUpdate: true,
          secondaryCaseOwnerSearch: {
            name: value.email,
            value: value.email
          }
        });
      }
    }
    let showOptions = {
      caseRequestorSearch: false,
      primaryCaseOwnerSearch: false,
      secondaryCaseOwnerSearch: false
    }
    this.setState({ showOptions: { ...showOptions } });
  }


  filterList = (event) => {
    var name = event.target.id;
    var query = event.target.value;
    this.setState({
      caseOwnerValue: query,
      selectedOwner: '',
    });
    let showOptions = {}
    if (name === "caseRequestorSearch") {
      showOptions = {
        caseRequestorSearch: true,
        primaryCaseOwnerSearch: false,
        secondaryCaseOwnerSearch: false
      }
    } else if (name === "primaryCaseOwnerSearch") {
      showOptions = {
        caseRequestorSearch: false,
        primaryCaseOwnerSearch: true,
        secondaryCaseOwnerSearch: false
      }
    } else if (name === "secondaryCaseOwnerSearch") {
      showOptions = {
        caseRequestorSearch: false,
        primaryCaseOwnerSearch: false,
        secondaryCaseOwnerSearch: true
      }
    }
    if (query.length > 2) {
      this.setState({ showCreateEntity: true });
      let url = '/users/search?emailId=' + query;
      eapiClient(url, { noBlocking: true })
        .then(({ data }) => {
          if (data.responseStatus.serviceErrorCode !== 404 && Array.isArray(data.responseData)) {
            this.setState({
              options: data.responseData,
              showOptions: { ...showOptions }
            });
          } else {
            showOptions = {
              caseRequestorSearch: false,
              primaryCaseOwnerSearch: false,
              secondaryCaseOwnerSearch: false
            }
            this.setState({ showOptions: { ...showOptions } });
          }
        });
    } else {
      if (name === "primaryCaseOwnerSearch" && query.length === 0) {
        this.setState({
          caseOwnerPrimaryUpdate: true,
          primaryCaseOwnerSearch: {
            name: '',
            value: ''
          }
        });
      } else if (name === "secondaryCaseOwnerSearch" && query.length === 0) {
        this.setState({
          caseOwnerSecondaryUpdate: true,
          secondaryCaseOwnerSearch: {
            name: '',
            value: ''
          }
        });
      }


      showOptions = {
        caseRequestorSearch: false,
        primaryCaseOwnerSearch: false,
        secondaryCaseOwnerSearch: false
      }
      this.setState({ showOptions: { ...showOptions } });
    }
  }

  renderTableData() {
    let rows = [];
    if (this.state.scannedUploads !== undefined && this.state.scannedUploads.length > 0) {
      this.state.scannedUploads.map((upload) => {
        const { id, fileName, createdOn } = upload;
        rows.push(
          <tr className="scanned-uploads">
            <td id={id} className="scanned-upload-item clearfix">{fileName}</td>
            <td className="scanned-upload-item_createdDate">{moment(createdOn).format("DD MMM YY")}</td>
            <td> <i className="icon icon-bin" role="button"
              onClick={this.onFileDelete.bind(this, upload)}></i></td>
          </tr>)
      })
    }
    return rows;
  }

  validateRAFNumber = (rafNumber) => {
    eapiClient(`/cases/${rafNumber}/pack-details`)
      .then(({ data: { responseData } }) => {
        this.props.rafPackDetails(responseData = { ...responseData, isRafPack: false });
      }).catch(({ response }) => {
        if (response.status === 404) {
          this.props.rafPackNotFound(response.status)
        }
      });
  }

  onSubmit = (data) => {
    this.setState({
      documentationDetails: {
        ...this.state.documentationDetails,
        RAF: data.caseId
      }
    })
    this.props.rafPackDetails(data = { ...data, isRafPack: true });
  }


  renderFormGroups() {
    let formData = this.state.formData;

    if (this.state.documentationDetails !== undefined) {
      console.log("this.state.documentationDetails", this.state.documentationDetails);
      formData = this.state.documentationDetails
    }
    const properties = {
      formData,
      editType: 'add-manual-case-documentation-details',
      pathname: this.props.history.location.pathname
    };
    if (this.props.pageJson !== undefined && this.props.pageJson.aemform_ManualCaseDocumentation !== undefined && this.state.scannedUploadsJson !== undefined) {
      return (
        <div className="documentation-page">
          {!this.props.msaCases && (
            <Dynamicform
              mode={this.state.mode}
              properties={properties}
              url={FORM_REFS[this.props.pageJson.aemform_ManualCaseDocumentation.formRef]}
              getFormData={this.getFormData}
              onFormSubmit={this.onFormSubmit}
              options={this.state.options}
              csCancelReason={this.state.csCancelReason}
              csCancelStatus={this.state.csCancelStatus}
              displayOptions={this.displayOptions}
              resetEntity={this.resetEntity}
              validateRAFNumber={this.validateRAFNumber}
              entityFromPack={this.state.Entity}
              resetValues={this.resetValues}
              setSelectedOptions={this.setSelectedOptions}
              checkForConflictsStatus={false}
              onSubmit={this.onSubmit}
              showOptions={this.state.showOptions}
              hideButtons={false}
              rafValidationPopup={this.state.rafValidationPopup}
              routingFlag={false}
              filterList={this.filterList}
              disableSubmitOnClick={false}
              lang={this.props.lang.currentLang.lang}
              translatedData={this.props.lang.translatedData}
              flag={this.props.lang.currentLangFlag.flag}
              modalText={this.props.pageJson.static_text_modalText.text}
            // formDisabled={this.props.isTnC}
            />
          )}
          <div className="scanned-uploads-wrapper">
            <label className="add-scanned-uploads-label">{this.translations(this.state.scannedUploadsJson.static_text_scannedUploads.text)}</label>
            <div className="gdocs-file-upload">
              <table id='scanned-uploads-section'>
                <tbody>
                  {this.renderTableData()}
                </tbody>
              </table>
              <label htmlFor="scanned-upload" className="gdocs-file-upload__label"><i className="icon icon-add"></i>{this.translations(this.state.scannedUploadsJson.button_addNew.text)}</label>
              <input id="scanned-upload" className="gdocs-file-upload__input" type="file" name="scanned-upload" onChange={this.onFileUpload} />
            </div>
          </div>
        </div>
      );
    }
  }

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  render() {
    const containerCss = classnames("manual-case-documentation", {
      "padding-40": !this.props.history.location.pathname.includes("/admin-panel/")
    });
    return (
      <div className={containerCss}>
        <div className="form-container">
          {this.renderFormGroups()}
        </div>
      </div>
    )
  }
}


const mapStateToProps = (state, props) => {
  return {
    lang: state.lang,
    loginDetails: state.auth.userDetails,
    caseId: state.newManualCase.caseId,
    caseNum: state.newManualCase.caseNum === undefined ? state.newManualCase.packNumber : state.newManualCase.caseNum
  }
}

const mapDispatchToProps = dispatch => {
  return {
    rafPackDetails: (newRAFPack) => {
      dispatch(rafPackDetails(newRAFPack))
    },
    deleteRafPackDetails: () => {
      dispatch(deleteRafPackDetails())
    },
    rafPackNotFound: (status) => {
      dispatch(rafPackNotFound(status))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Documentation);



// WEBPACK FOOTER //
// ./src/components/Admin/CaseBody/SubComp/Documentation.js